const RenameColumnImportData = function (type, columns) {
  if (type === "stores") {
    columns["category"] = columns["category_id"]
    columns["subcategory"] = columns["subcategory_id"]
    delete columns["category_id"]
    delete columns["subcategory_id"]
  }
  return columns
}
export default RenameColumnImportData